// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_e0-b";
export var colorBlue = "_e0-8";
export var colorDot = "_e0-0";
export var colorDotLarge = "_e0-2";
export var colorDotSmall = "_e0-1";
export var colorGreen = "_e0-7";
export var colorGrey = "_e0-3";
export var colorOrange = "_e0-5";
export var colorPink = "_e0-a";
export var colorPurple = "_e0-9";
export var colorRed = "_e0-4";
export var colorYellow = "_e0-6";